<!-- 来电记录 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd" icon="plus">新建工单</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div> -->
    <div>
      <div style="position: absolute;right: 10px;z-index: 99;">
        <a-button @click="onKnow" type="primary">{{ $t('知识库') }}</a-button>
      </div>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" :tab="$t('工单信息')">
          <WorkOrderRecord />
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('用户基本信息')">
          <BasicUserInformation />
        </a-tab-pane>
        <a-tab-pane key="3" :tab="$t('价格信息')">
          <priceIndex />
        </a-tab-pane>
        <a-tab-pane key="4" :tab="$t('营业网点')">
          <BusinessOutlets />
        </a-tab-pane>
        <a-tab-pane key="5" :tab="$t('留言信息')">
          <MessageInformation />
        </a-tab-pane>
      </a-tabs>
    </div>
    <workModal ref="modalForm"></workModal>
    <KnowledgeBaseQuery ref="KnowledgeBaseQueryRef"/>
  </a-card>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  // import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import priceIndex from './priceIndex'
  import BasicUserInformation from './BasicUserInformation'
  import WorkOrderRecord from './WorkOrderRecord'
  import BusinessOutlets from './BusinessOutlets'
  import MessageInformation from './MessageInformation'
  import KnowledgeBaseQuery from './KnowledgeBaseQuery'
  import workModal from '@/views/workOrderManagement/workManagement/modules/workModal.vue'
  

  export default {
    name: 'AttendantConsoleIndex',
    mixins:[mixinDevice,TableDragResize],
    components: {
      priceIndex,
      BasicUserInformation,
      WorkOrderRecord,
      BusinessOutlets,
      MessageInformation,
      KnowledgeBaseQuery,
      workModal,
      JInput
    },
    data () {
      return {
        description: '话务台',
        model:{},
        // url: {
        //   list: "/jeecg-hotline/caller/callerHistory/list",
        //   delete: "/jeecg-hotline/caller/callerHistory/delete",
        //   deleteBatch: "/jeecg-hotline/caller/callerHistory/deleteBatch",
        //   userList: "/sys/user/list",
        // },
      }
    },
    created() {},
    mounted(){},
    computed: {},
    methods: {
      handleAdd(){
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = this.$t('新增');
        this.$refs.modalForm.disableSubmit = false;
      },
      onKnow(){
        this.$refs.KnowledgeBaseQueryRef.show();
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>